import omnidotsLogo from '../../../../../seasonal/logos/omnidots-logo.svg';
import type { RuntimeImageAsset, SystemImageAssetKey } from '../contracts';

export interface SystemImageAsset {
    key: SystemImageAssetKey;
    label: string;
    description: string;
}

// Single source for `system_assets.image`; a function so `gettext` runs after catalog load.
export function listSystemImageAssets(): readonly SystemImageAsset[] {
    return [
        {
            key: 'omnidots_logo',
            label: gettext('DATA_SERVICE_SYSTEM_ASSETS_OMNIDOTS_LOGO_LABEL'),
            description: gettext('DATA_SERVICE_SYSTEM_ASSETS_OMNIDOTS_LOGO_DESCRIPTION'),
        },
        {
            key: 'profile_logo',
            label: gettext('DATA_SERVICE_SYSTEM_ASSETS_PROFILE_LOGO_LABEL'),
            description: gettext('DATA_SERVICE_SYSTEM_ASSETS_PROFILE_LOGO_DESCRIPTION'),
        },
    ];
}

function getSystemImageAssetOrThrow(value: unknown, errorLabel: string): SystemImageAsset {
    const asset =
        typeof value === 'string'
            ? listSystemImageAssets().find((candidate) => candidate.key === value)
            : undefined;

    if (!asset) {
        throw new Error(`Expected "${errorLabel}" to be a known system image asset key.`);
    }

    return asset;
}

export function normalizeSystemImageAssetKey(
    value: unknown,
    errorLabel: string
): SystemImageAssetKey {
    return getSystemImageAssetOrThrow(value, errorLabel).key;
}

export function createSystemImageAssetArgOptions(): ReadonlyArray<readonly [string, string]> {
    return listSystemImageAssets().map((asset): readonly [string, string] => [
        asset.key,
        asset.label,
    ]);
}

export function getOmnidotsLogoAsset(): RuntimeImageAsset {
    return { url: omnidotsLogo, caption: '' };
}
